<template>
  <div class="content-wrapper">
    <ContentHeader title="Топливные карты" />
    <div class="content-body">
      <BillTable
        title="ДЕТАЛИЗАЦИЯ ПО ТОПЛИВНЫМ КАРТАМ"
        topCaption
        :itemsPerPage="10"
        :fields="fields"
        :items="getTransactions"
        :filterIncludedFields="filterOn"
        :filter="
          searchText || dateFrom || dateTo
            ? { searchText, dateFrom, dateTo }
            : null
        "
        :filterFunction="filterTransactions"
        :busy="isCardsTransactionsLoading"
        :failed="isCardsTransactionsFailed"
        @reload="reloadTransactions"
      >
        <template slot="top">
          <div class="card-block">
            <div class="row">
              <div class="col-md-2">
                <div class="form-group">
                  <div class="position-relative has-icon-left">
                    <input
                      type="text"
                      class="form-control bg-grey bg-lighten-4"
                      placeholder="Поиск по детализации"
                      v-model="searchText"
                    />
                    <div class="form-control-position">
                      <i class="icon-search4"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <datepicker
                    format="DD.MM.YYYY"
                    placeholder="Искать после"
                    input-class="form-control bg-grey bg-lighten-4"
                    style="width: 100%"
                    v-model="dateFrom"
                  ></datepicker>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <datepicker
                    format="DD.MM.YYYY"
                    placeholder="Искать до"
                    input-class="form-control bg-grey bg-lighten-4"
                    style="width: 100%"
                    v-model="dateTo"
                  ></datepicker>
                </div>
              </div>
              <div class="col-md-2 offset-md-2 offset-sd-0">
                <div class="form-group">
                  <button
                    type="button"
                    class="btn btn-block btn-secondary"
                    @click="createReport"
                    :disabled="!dateFrom || !dateTo"
                    :title="
                      !dateFrom || !dateTo
                        ? 'Укажите даты начала и окончания периода'
                        : ''
                    "
                  >
                    <i class="icon-download4"></i> Построить отчёт .pdf
                  </button>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <DownloadTableXLSXButton
                    class="btn-block"
                    filename="Детализация по топливным картам"
                    :fields="fields"
                    :items="filteredTransactions"
                    >Скачать историю .xlsx</DownloadTableXLSXButton
                  >
                </div>
              </div>
            </div>
          </div>
        </template>
      </BillTable>
    </div>
  </div>
</template>

<script>
import ContentHeader from "@/components/ContentHeader.vue";
import BillTable from "@/components/BillTable";
import DownloadTableXLSXButton from "@/components/DownloadTableXLSXButton.vue";
import { mapGetters } from "vuex";
import {
  CARDS_TRANSACTIONS_REQUEST,
  CARDS_GET_REPORT,
} from "@/store/actions/cards";
import pdfMake from "@/utils/pdfmake.min.js";
import pdfFonts from "@/utils/vfs_fonts.min.js";

export default {
  name: "CardsTransactions",
  components: {
    ContentHeader,
    BillTable,
    DownloadTableXLSXButton,
  },
  data() {
    return {
      searchText: null,
      dateFrom: null,
      dateTo: null,
      fields: [
        {
          key: "date",
          label: "Дата",
          formatter: (value, key, item) => {
            return new Date(item.sdate).toLocaleDateString();
          },
          filterByFormatted: true,
        },
        {
          key: "time",
          label: "Время",
          formatter: (value, key, item) => {
            return new Date(item.sdate).toLocaleTimeString();
          },
          filterByFormatted: true,
        },
        {
          key: "card_id",
          label: "№ Карты",
        },
        {
          key: "holder_name",
          label: "Держатель",
        },
        {
          key: "azs",
          label: "АЗС",
          formatter: (value, key, item) => {
            return `АЗС №${value} ${item.region}`;
          },
          filterByFormatted: true,
        },
        {
          key: "type",
          label: "Баланс списания",
          formatter: (value) => {
            return value === 0 ? "Литровый" : "Денежный";
          },
          filterByFormatted: true,
        },
        {
          key: "product",
          label: "Товар",
        },

        {
          key: "quantity",
          label: "Количество",
          type: Number,
        },
        {
          key: "cost",
          label: "Сумма",
          type: Number,
        },
      ],
      filterOn: [
        "card_id",
        "holder_name",
        "azs",
        "product",
        "quantity",
        "cost",
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getTransactions",
      "cardsTransactionsOnceLoaded",
      "isCardsTransactionsLoading",
      "isCardsTransactionsFailed",
      "getCurrencyName",
    ]),
    filteredTransactions() {
      if (!(this.searchText || this.dateFrom || this.dateTo)) {
        return this.getTransactions;
      } else {
        const filter = {
          searchText: this.searchText,
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
        };
        return this.getTransactions.filter((t) =>
          this.filterTransactions(t, filter)
        );
      }
    },
  },
  methods: {
    reloadTransactions() {
      this.$store.dispatch(CARDS_TRANSACTIONS_REQUEST);
    },
    filterTransactions(tr, filter) {
      if (!filter) return;

      let d = new Date(tr.sdate);
      if (filter.dateFrom && d < filter.dateFrom) return false;
      if (filter.dateTo && d > filter.dateTo) return false;

      if (!filter?.searchText) return true;
      let rex = new RegExp(filter.searchText, "i");
      for (let i = 0; i < this.filterOn.length; i++) {
        const fname = this.filterOn[i];
        if (rex.test(String(tr[fname]))) return true;
      }
    },
    createReport() {
      console.log(this.dateFrom, this.dateTo);

      this.$store
        .dispatch(CARDS_GET_REPORT, {
          date_from: this.dateFrom.toLocaleDateString(),
          date_to: this.dateTo.toLocaleDateString(),
        })
        .then((response) => this.printReport(response.data))
        .catch((err) => console.log(err));
    },
    printReport(data) {
      console.log(data);
      pdfMake.vfs = pdfFonts.pdfMake.vfs;

      let styles = {
        header: {
          fontSize: 10,
          bold: true,
          alignment: "center",
          margin: [0, 0, 0, 10],
        },
        subheader: {
          fontSize: 10,
          bold: true,
          margin: [0, 0, 0, 5],
        },
        small: {
          fontSize: 8,
          alignment: "right",
        },
        table: {
          margin: [0, 0, 0, 10],
        },
        tableHeader: {
          bold: true,
          fillColor: "#CCCCCC",
          alignment: "center",
          fontSize: 10,
        },
      };

      let defaultStyle = {
        fontSize: 10,
      };

      let currency_name = this.getCurrencyName;
      let currency_name_full = this.getCurrencyName;

      let d = data?.head || {};
      var dd = {
        pageOrientation: "landscape",
        content: [
          { text: "Создан " + d.author + " " + d.createDate, style: "small" },
          {
            text: "Детализированный отчёт по топливным картам",
            style: "header",
            margin: [0, 0, 0, 5],
          },
          {
            text: "по клиенту " + d.clientName,
            style: "header",
            margin: [0, 0, 0, 5],
          },
          {
            text: "за период с " + d.startDate + " по " + d.endDate,
            style: "header",
          },
        ],
        styles: styles,
        defaultStyle: defaultStyle,
      };

      let inMoney = data?.body?.incoming?.money_summary_money != null;
      let inVolume = data?.body?.incoming?.volume_summary_products != null;
      if (inMoney || inVolume) {
        let incomingTable = {
          table: {
            headerRows: 2,
            body: [
              [
                {
                  text: "Входящий остаток",
                  style: "subheader",
                  colSpan: 3,
                  border: [false, false, false, false],
                },
                "",
                "",
              ],
              [
                { text: "Тип", style: "tableHeader" },
                { text: "Литры", style: "tableHeader" },
                { text: "Сумма", style: "tableHeader" },
              ],
            ],
          },
          style: "table",
        };
        if (inMoney) {
          incomingTable.table.body.push([
            currency_name_full,
            "",
            data.body.incoming.money_summary_money,
          ]);
        }

        if (inVolume) {
          d = data.body.incoming.volume_summary_products;
          for (let i = 0; i < d.length; i++) {
            incomingTable.table.body.push([
              d[i].product_name,
              d[i].incoming_volume,
              d[i].incoming_money,
            ]);
          }
        }

        dd.content.push(incomingTable);
      } else {
        dd.content.push({
          text: "Входящий остаток за данный период отсутствует",
          style: "subheader",
        });
      }

      d = data?.body?.supplies;
      if (d != null) {
        let suppliesTable = {
          table: {
            headerRows: 2,
            body: [
              [
                {
                  text: "Пополнение за период",
                  style: "subheader",
                  colSpan: 6,
                  border: [false, false, false, false],
                },
                "",
                "",
                "",
                "",
                "",
              ],
              [
                { text: "Вид", style: "tableHeader" },
                { text: "Тип", style: "tableHeader" },
                { text: "Дата", style: "tableHeader" },
                { text: "Цена", style: "tableHeader" },
                { text: "Количество", style: "tableHeader" },
                { text: "Сумма", style: "tableHeader" },
              ],
            ],
          },
          style: "table",
        };
        for (let i = 0; i < d.length; i++) {
          suppliesTable.table.body.push([
            d[i].operation_name,
            d[i].product_name,
            d[i].date,
            d[i].price,
            d[i].quantity,
            d[i].cost,
          ]);
        }
        dd.content.push(suppliesTable);
      } else {
        dd.content.push({
          text: "Поступления за данный период отсутствуют",
          style: "subheader",
        });
      }

      d = data?.body?.tables;
      if (d != null) {
        for (let i = 0; i < d.length; i++) {
          let ca = data.body.tables[i];
          let h =
            (ca.type == "money" ? "Денежная" : "Топливная") +
            " реализация на АГЗС по счёту «" +
            ca.name +
            "» за период";
          let txTable = "";
          if (ca.rows == null || ca.rows.length == 0) {
            h += " отсутствует";
          } else {
            if (ca.type == "volume") {
              txTable = {
                table: {
                  headerRows: 2,
                  body: [
                    [
                      {
                        text: h,
                        style: "subheader",
                        colSpan: 11,
                        border: [false, false, false, false],
                      },
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                    ],
                    [
                      { text: "Начало", style: "tableHeader" },
                      { text: "Окончание", style: "tableHeader" },
                      { text: "Регион", style: "tableHeader" },
                      { text: "АГЗС", style: "tableHeader" },
                      { text: "НП", style: "tableHeader" },
                      { text: "Тип", style: "tableHeader" },
                      { text: "Отпущено, л.", style: "tableHeader" },
                      { text: `Цена, ${currency_name}.`, style: "tableHeader" },
                      {
                        text: `Сумма, ${currency_name}.`,
                        style: "tableHeader",
                      },
                      { text: "Карта", style: "tableHeader" },
                      { text: "Держатель", style: "tableHeader" },
                    ],
                  ],
                },
                style: "table",
              };

              for (let j = 0; j < ca.rows.length; j++) {
                let tx = ca.rows[j];
                txTable.table.body.push([
                  tx.date,
                  tx.edate,
                  tx.region_name,
                  tx.azs_name,
                  tx.product_name,
                  tx.type_name,
                  tx.quantity,
                  tx.price,
                  tx.cost,
                  tx.card_id,
                  tx.holder_name,
                ]);
              }

              if (ca.summary == null || ca.summary == undefined) continue;
              for (let j = 0; j < ca.summary.length; j++) {
                let s = ca.summary[j];
                txTable.table.body.push([
                  { text: "итого:", style: "tableHeader" },
                  { text: "", style: "tableHeader" },
                  { text: "", style: "tableHeader" },
                  { text: "", style: "tableHeader" },
                  { text: s.product_name, style: "tableHeader" },
                  { text: "", style: "tableHeader" },
                  { text: s.volume, style: "tableHeader" },
                  { text: "", style: "tableHeader" },
                  { text: s.cost, style: "tableHeader" },
                  { text: "", style: "tableHeader" },
                  { text: "", style: "tableHeader" },
                ]);
              }
            } else {
              txTable = {
                table: {
                  headerRows: 2,
                  body: [
                    [
                      {
                        text: h,
                        style: "subheader",
                        colSpan: 14,
                        border: [false, false, false, false],
                      },
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                    ],
                    [
                      { text: "Начало", style: "tableHeader" },
                      { text: "Окончание", style: "tableHeader" },
                      { text: "Регион", style: "tableHeader" },
                      { text: "АГЗС", style: "tableHeader" },
                      { text: "НП", style: "tableHeader" },
                      { text: "Тип", style: "tableHeader" },
                      { text: "Отпущено, л.", style: "tableHeader" },
                      { text: `Цена, ${currency_name}.`, style: "tableHeader" },
                      {
                        text: `Сумма, ${currency_name}.`,
                        style: "tableHeader",
                      },
                      {
                        text: `Скидка, ${currency_name}.`,
                        style: "tableHeader",
                      },
                      {
                        text: `Итого скидка, ${currency_name}.`,
                        style: "tableHeader",
                      },
                      {
                        text: `Итого сумма, ${currency_name}.`,
                        style: "tableHeader",
                      },
                      { text: "Карта", style: "tableHeader" },
                      { text: "Держатель", style: "tableHeader" },
                    ],
                  ],
                },
                style: "table",
              };

              for (let j = 0; j < ca.rows.length; j++) {
                let tx = ca.rows[j];
                txTable.table.body.push([
                  tx.date,
                  tx.edate,
                  tx.region_name,
                  tx.azs_name,
                  tx.product_name,
                  tx.type_name,
                  tx.quantity,
                  tx.price,
                  tx.cost,
                  tx.discount,
                  tx.discount_sum,
                  tx.total_cost,
                  tx.card_id,
                  tx.holder_name,
                ]);
              }

              if (ca.summary == null || ca.summary == undefined) continue;
              txTable.table.body.push([
                { text: "итого:", style: "tableHeader" },
                { text: "", style: "tableHeader" },
                { text: "", style: "tableHeader" },
                { text: "", style: "tableHeader" },
                { text: "", style: "tableHeader" },
                { text: "", style: "tableHeader" },
                { text: "", style: "tableHeader" },
                { text: "", style: "tableHeader" },
                { text: ca.summary.cost, style: "tableHeader" },
                { text: "", style: "tableHeader" },
                { text: ca.summary.discount_sum, style: "tableHeader" },
                { text: ca.summary.total_cost, style: "tableHeader" },
                { text: "", style: "tableHeader" },
                { text: "", style: "tableHeader" },
              ]);
            }
          }
          dd.content.push(txTable);
        }
      } else {
        dd.content.push({
          text: "Транзакции за данный период отсутствуют",
          style: "subheader",
        });
      }

      d = data?.body?.summary?.money;
      if (d != null) {
        let totalMoneyTable = {
          table: {
            headerRows: 2,
            body: [
              [
                {
                  text: "Итого по денежным транзакциям за период",
                  style: "subheader",
                  colSpan: 4,
                  border: [false, false, false, false],
                },
                "",
                "",
                "",
              ],
              [
                { text: "Вх.остаток", style: "tableHeader" },
                { text: "Пополнения", style: "tableHeader" },
                { text: "Реализация", style: "tableHeader" },
                { text: "Исх.остаток", style: "tableHeader" },
              ],
              [d.incoming, d.supplies, d.transactions, d.outgoing],
            ],
          },
          style: "table",
        };
        dd.content.push(totalMoneyTable);
      }

      d = data?.body?.summary?.volume;
      if (d != null) {
        let totalFuelTable = {
          table: {
            headerRows: 3,
            body: [
              [
                {
                  text: "Итого по топливным транзакциям за период",
                  style: "subheader",
                  colSpan: 9,
                  border: [false, false, false, false],
                },
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
              ],
              [
                { text: "НП", style: "tableHeader", rowSpan: 2 },
                { text: "Вх.остаток", style: "tableHeader", colSpan: 2 },
                "",
                { text: "Пополнения", style: "tableHeader", colSpan: 2 },
                "",
                { text: "Реализация", style: "tableHeader", colSpan: 2 },
                "",
                { text: "Исх.остаток", style: "tableHeader", colSpan: 2 },
                "",
              ],
              [
                "",
                { text: "л", style: "tableHeader" },
                { text: currency_name, style: "tableHeader" },
                { text: "л", style: "tableHeader" },
                { text: currency_name, style: "tableHeader" },
                { text: "л", style: "tableHeader" },
                { text: currency_name, style: "tableHeader" },
                { text: "л", style: "tableHeader" },
                { text: currency_name, style: "tableHeader" },
              ],
            ],
          },
          style: "table",
        };
        for (let i = 0; i < d.length; i++) {
          totalFuelTable.table.body.push([
            d[i].product_name,
            d[i].incoming_volume,
            d[i].incoming_money,
            d[i].supplies_volume,
            d[i].supplies_money,
            d[i].transactions_volume,
            d[i].transactions_money,
            d[i].remain_volume,
            d[i].remain_money,
          ]);
        }
        dd.content.push(totalFuelTable);
      }

      pdfMake
        .createPdf(dd)
        .download(
          `Отчёт по топливным картам за период с ${data?.head?.startDate} по ${data?.head?.endDate}.pdf`
        );
    },
  },
  created() {
    if (!this.cardsTransactionsOnceLoaded)
      this.$store.dispatch(CARDS_TRANSACTIONS_REQUEST);
  },
};
</script>